import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormikContext } from 'formik';
import lodashGet from 'lodash/get';
const styles = {
    container: {
        padding: '0.4rem',
        display: 'flex',
        flexDirection: 'column',
    },
    text: {
        color: '#fd000c',
        margin: '0.5px',
        fontSize: '0.9em',
    },
};
function FormikError({ style, name, children }) {
    const { errors, isValid, dirty, touched } = useFormikContext();
    const errorText = lodashGet(errors, name);
    const isTouched = lodashGet(touched, name);
    return (_jsxs("div", { style: { ...styles.container, ...style?.container }, children: [children, !isValid && dirty && isTouched && (_jsx("span", { style: { ...styles.text, ...style?.text }, children: errorText }))] }));
}
export default FormikError;
